import React from 'react'
import { connect } from 'react-redux'
import '../set-ideal-wind/index.scss'
import CompassOverlay3D from '../compass-overlay-3d'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import huntImage from '../../../../../../asset/Wind-Icon_Large_FFFFFF_SVG.svg'
import standIconWhite from '../../../../../../asset/stand-icon.png'

class SetIdealWinds3D extends React.Component {
  constructor(props) {
    super(props)
    this.compassOverlay = null
    this.setWinds = this.setWinds.bind(this)
    this.updateWinds = this.updateWinds.bind(this)
  }

  componentDidMount() {
    const { markerData, winds } = this.props
    this.compassOverlay = new CompassOverlay3D({
      iconUrl: markerData.markerType?.iconUrl || markerData.markerType?.vectorIconUrl,
      markerColor: markerData.color || '9ECC3B',
      markerData,
      windsData: winds,
      map: this.props.mapReferenceThreed,
    })
    this.compassOverlay.mount()
    this.compassOverlay.updateWinds(winds)
    this.compassOverlay.updateWindsCallback = this.updateWinds
  }

  componentWillUnmount() {
    if (this.compassOverlay) {
      this.compassOverlay.unmount()
    }
  }

  componentDidUpdate() {
    if (this.compassOverlay) {
      this.compassOverlay.updateWinds(this.props.winds)
    }
  }

  updateWinds(selectedWind) {
    this.valueOfchild(selectedWind)
  }

  setWinds(e) {
    if (!e.target.form) {
      e.preventDefault()
    }
    const form = e.target.form ? e.target.form : e.target
    const formData = new FormData(form)
    const winds = []
    for (let entry of formData.entries()) {
      winds.push(entry[0])
    }
    this.props.setWinds(winds)
    if (!e.target.form) {
      this.props.saveMarker(winds)
    }
  }

  valueOfchild(value) {
    const opposites = { n: 's', s: 'n', e: 'w', w: 'e', ne: 'sw', sw: 'ne', se: 'nw', nw: 'se' }
    const reversed = opposites[value]
    if (!reversed) return
    const winds = new Set(this.props.winds)
    winds.has(reversed) ? winds.delete(reversed) : winds.add(reversed)
    this.props.setWinds([...winds])
  }

  getChecked(dir) {
    return this.props.winds.indexOf(dir) !== -1
  }

  makeInputs() {
    const dirs = ['n', 's', 'ne', 'sw', 'e', 'w', 'se', 'nw']
    return dirs.map(dir => (
      <label className='ideal-wind-option' key={`wind-option-${dir}`}>
        <input
          type='checkbox'
          style={{ scale: '1.5', marginRight: '10px' }}
          checked={this.getChecked(dir)}
          name={dir}
          onChange={this.setWinds}
        />{dir.toUpperCase()}
      </label>
    ))
  }

  makeTextInput(name, displayVal) {
    return (
      <div style={{ width: '96.2%', height: 68, marginTop: 10 }} key={`markerInput-${name}`}>
        <label htmlFor={name} className='label-style' style={{ fontSize: '12px', textTransform: 'capitalize' }}>
          {name}:
        </label>
        <input
          type='text'
          name={name}
          id={name}
          style={{ background: '#333333', opacity: 1, marginTop: 5, width: '84%', height: 40, border: 'none', borderRadius: 5, padding: '0 10px' }}
          value={displayVal}
          readOnly
        />
      </div>
    )
  }

  render() {
    const { markerData } = this.props
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ border: '2px solid #589500', borderRadius: 5, width: 35, height: 35, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10 }}>
            <img src={standIconWhite} />
          </div>
          <h3 style={{ color: '#ffffff', font: 'normal normal normal 30px/45px Oswald' }}>Add HuntWind&#8482;</h3>
        </div>

        {this.makeTextInput('name', markerData.name)}

        <div style={{ color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', alignItems: 'center', marginBottom: 10 }}>
          <h3 style={{ color: '#ffffff', font: 'normal normal normal 30px/45px Oswald' }}>HuntWind&#8482;</h3>
          <img src={huntImage} style={{ width: '39px', height: '14px', marginTop: 10 }} />
        </div>
        <div className='hunt-wind-header-save'>Select Ideal Wind Direction(s)</div>
        <div className='hunt-wind-prompt-save'>
          Select the wind direction(s) that are most likely to keep your scent from being detected
        </div>

        <form className='ideal-winds-form' onSubmit={this.setWinds}>
          {this.makeInputs()}
          <button
            type='button'
            onClick={() => this.props.setMarkerData(null)}
            style={{ width: '50%', marginLeft: '-20%', backgroundColor: '#4F4F4F', opacity: '1' }}
          >
            Back
          </button>
          <button style={{ width: '50%' }} type='submit' name='doneButton'>Save</button>
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  mapReferenceThreed: state.mapReferenceThreed,
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetIdealWinds3D)
